// Calculateur pour les Bateaux
function calculateTaxBoat() {
  const anneeConstruction = parseInt(document.getElementById('annee_construction').value);
  const longueurCoque = parseFloat(document.getElementById('longueur_coque').value);
  const nombreMoteurs = parseInt(document.getElementById('nombre_moteurs').value);
  const puissanceAdmin = parseFloat(document.getElementById('puissance_admin').value);

  if (isNaN(anneeConstruction) || isNaN(longueurCoque) || isNaN(nombreMoteurs) || isNaN(puissanceAdmin)) {
    document.getElementById('errorMessageBoat').style.display = 'block';
    return;
  }
  document.getElementById('errorMessageBoat').style.display = 'none';

  let taxeCoque = 0;
  if (longueurCoque <= 7) taxeCoque = 77;
  else if (longueurCoque <= 8) taxeCoque = 105;
  else if (longueurCoque <= 9) taxeCoque = 178;
  else if (longueurCoque <= 10) taxeCoque = 240;
  else if (longueurCoque <= 12) taxeCoque = 458;
  else if (longueurCoque <= 15) taxeCoque = 886;

  let taxeMoteur = 0;
  const puissanceTaxable = Math.max(0, puissanceAdmin - 5);
  for (let i = 0; i < nombreMoteurs; i++) {
    taxeMoteur += calculerTaxeMoteur(puissanceTaxable);
  }

  let abattement = calculerAbattement(anneeConstruction);
  let abandonAbattement = false;

  // Abandon de l'abattement si puissance admin > 100 CV
  if (puissanceAdmin > 100) {
    abattement = 0;
    abandonAbattement = true;
  }

  const taxeTotale = Math.floor((taxeCoque + taxeMoteur) * (1 - abattement));

  let message = `Le montant total de la taxe est de <strong>${taxeTotale} €</strong>.`;
  if (abandonAbattement) {
    message += "<br><strong>Note :</strong> L'abattement pour vétusté a été annulé car la puissance administrative dépasse 100 CV.";
  }
  if (taxeTotale < 76) {
    message += "<br><strong>Exonération :</strong> le montant de la taxe est inférieur à 76 €, vous êtes exonéré.";
  }

  const resultDiv = document.getElementById('resultBoat');
  resultDiv.style.display = 'block';
  resultDiv.innerHTML = message;
}

function calculerTaxeMoteur(puissance) {
  if (puissance <= 8) return puissance * 14;
  if (puissance <= 10) return puissance * 16;
  if (puissance <= 20) return puissance * 35;
  if (puissance <= 25) return puissance * 40;
  if (puissance <= 50) return puissance * 44;
  if (puissance <= 99) return puissance * 50;
  return puissance * 64;
}

function calculerAbattement(annee) {
  if (annee < 1993) return 0.8;
  if (annee >= 1993 && annee <= 1997) return 0.55;
  if (annee >= 1998 && annee <= 2007) return 0.33;
  return 0;
}

// Calculateur pour les VNM
function calculateTaxVNM() {
  const anneeConstructionVNM = parseInt(document.getElementById('annee_construction_vnm').value);
  const puissanceVNM = parseFloat(document.getElementById('puissance_vnm').value);

  if (isNaN(anneeConstructionVNM) || isNaN(puissanceVNM)) {
    document.getElementById('errorMessageVNM').style.display = 'block';
    return;
  }
  document.getElementById('errorMessageVNM').style.display = 'none';

  let taxeVNM = 0;

  if (puissanceVNM >= 90 && puissanceVNM < 160) {
    taxeVNM = puissanceVNM * 3;
  } else if (puissanceVNM >= 160) {
    taxeVNM = puissanceVNM * 4;
  }

  const abattement = calculerAbattement(anneeConstructionVNM);
  taxeVNM = Math.floor(taxeVNM * (1 - abattement));

  let message = `Le montant total de la taxe pour le VNM, après abattement pour vétusté, est de <strong>${taxeVNM} €</strong>.`;
  if (taxeVNM === 0) {
    message = "<strong>Exonération :</strong> La puissance du VNM est inférieure à 90 kW.";
  }

  const resultDiv = document.getElementById('resultVNM');
  resultDiv.style.display = 'block';
  resultDiv.innerHTML = message;
}
